import React from 'react';
import Linkify from 'react-linkify';
import { makeStyles, Box, Typography } from '@material-ui/core';
import { ellipsize } from '../../utils/textUtil';
import AnyLink from './anyLink';

const LinkifyComponent = ({ content, shouldTruncate, textLimit }) => {
  const classes = useStyles();

  const componentDecorator = (href, text, key) => (
    <AnyLink key={key} className={classes.linkColor} to={href}>
      {text}
    </AnyLink>
  );

  const viewMoreText = (
    <Box component="span" color="link.main">
      {` `}View more
    </Box>
  );

  return (
    <Linkify componentDecorator={componentDecorator}>
      <Typography
        className={classes.metaInfo}
        dangerouslySetInnerHTML={{
          __html: shouldTruncate ? ellipsize(content, textLimit) : content,
        }}
      />
      {shouldTruncate && content && content.length >= textLimit && viewMoreText}
    </Linkify>
  );
};

const useStyles = makeStyles((theme) => ({
  linkColor: {
    color: theme.palette.link.main,
    textDecoration: 'none',
  },
}));
export default LinkifyComponent;
